import { WeightGrid } from "@wizeoo/akm-message-lib";
import { Model } from "../../model/model";
import { WeightGridVO } from "../../vo/integration/weightgrid.vo";
import { MeasureVO } from "../../vo/workingdata/measure.vo";
import { WizConstants } from "../../model/constants";

/**
 * Manager de grilles de poids pour le moteur
 */
export class WeightGridEngine {

  protected _model: Model = null;
  constructor(model: Model) {
    this._model = model;
  }

  public getWeightGridMap(): Map<string, WeightGridVO> {
    return this._model.weightGridMap;
  }
  public setWeightGridMap(value: Map<string, WeightGridVO>) {
    this._model.weightGridMap = value;
  }

  /** retourne les WGs, sous forme de [] */
  public getWeightGrids(): WeightGridVO[] {
    if (this.getWeightGridMap()) {
        return [...this.getWeightGridMap().values()];
    }
    return null;
  }

  /**
   * Récupération d'un weightGrid par code
   * @param pCode Le code du wg recherché
   */
  public getWeightGrid(pCode: string): WeightGridVO {
    return this.getWeightGridMap()?.get(pCode) || null;
  }

  /**
   * gestion des Wgs comme des mesures
   * @returns 
   */
  public getWeightAsMeasureMap(): Map<string, MeasureVO> {
    return this._model.weightAsMeasureMap;
  }
  public setWeightAsMeasureMap(value: Map<string, MeasureVO>) {
    this._model.weightAsMeasureMap = value;
  }

  /**
   * alimentation des wgs du modèle
   * @param wgs WeightGrid[]
   */
  public feedWeightGrids(wgs: WeightGrid[]): void {
    if (!this.getWeightGridMap()) {
      this.setWeightGridMap(new Map());
      this.setWeightAsMeasureMap(new Map());
    }
    
    wgs.forEach((wg: WeightGrid) => {
        const wgVO: WeightGridVO = new WeightGridVO(this._model, wg);

        this.getWeightGridMap().set(wgVO.code, wgVO);
        // alimentation de la map de fake Measures
        const fakeMeasure: MeasureVO = this.buildWgMeasure(wgVO);
        this.getWeightAsMeasureMap().set(fakeMeasure.code, fakeMeasure);
    });
  }

  /**
   * construction d'une mesures isWeight pour alimentation de la grille
   * @param wg la grille de poids source
   * @returns MeasureVO
   */
  protected buildWgMeasure(wg: WeightGridVO): MeasureVO {
      const res: MeasureVO = new MeasureVO();
      res.mode = WizConstants.MEASURE_MODE_WEIGHT_GRID;
      res.code = wg.code;
      res.shortCode = wg.code; // pas de shortCode sur les Wgs
      res.formulaI = '';
      return res;
  }

}
